import React from 'react'
import { Grid, styled } from '@material-ui/core'
import { Form, FormSpy } from 'react-final-form'
import arrayMutators from 'final-form-arrays'

import useGenerateCertificate from './useGenerateCertificate'

import HeadCertificate from '../../../shareUI/headCertificate/headCertificate'
import MyAccordion from '../../../../../control/accordion/accordion'
import MyTextfield from '../../../../../control/textfield/textfield'
import DatePicker from '../../../../../control/datepicker/datepicker'
import UploadDoc from '../../../shareUI/uploadDoc/uploadDoc'
import PageAction from '../pageAction'

import useTranslate from '../../../../../i18n/useTranslate'
import { getDisable } from '../../../shareLogic/useFunctionHook'
import Dialog from '../../../../../control/dialog/dialog'
import useSnackbarAction from '../../../../../stores/snackbar/snackbarAction'
import DisplayUpdater from '../../../shareUI/displayUpdater/displayUpdater'
import ModeAccordion from '../../../shareUI/modeAccordion/ModeAccordion'
import useAppFolderAndTabStore from '../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import MyButton from '../../../../../control/button/button'

//ออกใบรับรอง
//View
export type GenerateCertificateREC2ViewType = { disabledFieldNames?: Array<string> | 'all' } & ReturnType<
    typeof useGenerateCertificate
>
const AddBtn = styled(MyButton)({
    color: 'white',
    marginLeft: '20px',
})

const GenerateCertificateREC2View: React.FC<GenerateCertificateREC2ViewType> = (props) => {
    const {
        formRef,
        valueRef,
        isViewMode,
        projectData,
        configDialog,
        initialValues,
        initialValuesOtherLanguage,
        isShowUpdateDate,
        disabledFieldNames,
        initialUploadCerDoc,
        formatDocumentTopic,
        certificateTopicList,
        initialUploadFileCer,
        certificateFieldNamesTH,
        certificateFieldNamesEN,
        onRefDialog,
        onSubmitForm,
        onClickOpenFile,
        onClickFileStamp,
        handleDirtyChange,
        onDateReqCertificateChange,
        handleBackToSearch,
        handleSubmitUpdateData,
        isUpdateSuccess,
        isAddOtherLanguage,
        handleCancelAddOtherLangauge,
        handleClickOtherLangauge,
    } = props
    const translate = useTranslate()
    const snackbarAction = useSnackbarAction()
    const appFolderAndTabStore = useAppFolderAndTabStore()
    const currentSelectTab = appFolderAndTabStore.tabSelected?.stepID === projectData?.stepID
    const latestFolderIdx = 0 // folder ล่าสุด
    const currentSelectFolder =
        appFolderAndTabStore.folderList[latestFolderIdx].submittedID === appFolderAndTabStore.folderSelected.submittedID

    const renderViewComponent = (language: string) => {
        return (
            <Grid container spacing={2} justify={'flex-end'}>
                <Grid item xs={12} md={12} lg={12}>
                    <HeadCertificate disabled={!currentSelectTab} language={language} />
                </Grid>
            </Grid>
        )
    }

    const renderEditComponent = (language: string) => {
        return (
            <Grid container spacing={2} justify={'flex-end'}>
                <Grid item xs={12} md={12} lg={12}>
                    <HeadCertificate language={language} />
                </Grid>
            </Grid>
        )
    }
    return (
        <Form
            onSubmit={onSubmitForm}
            initialValues={{
                ...initialValues,
                ...initialValuesOtherLanguage,
                uploadFile: initialUploadFileCer,
                uploadFileCerDoc: initialUploadCerDoc,
            }}
            mutators={{
                ...arrayMutators,
            }}
            keepDirtyOnReinitialize={true}
        >
            {(props) => {
                formRef.current = props
                const { invalid, errors, values } = props
                return (
                    <>
                        <Grid container spacing={2} justify={'flex-end'}>
                            <Grid item xs={12} md={12} lg={12}>
                                <MyAccordion title={translate.get('LABEL.COA_NO')}>
                                    <Grid container spacing={2} justify={'flex-end'}>
                                        <Grid item xs={12}>
                                            <Grid item xs={6}>
                                                <MyTextfield
                                                    name="coaNo"
                                                    materialInputProps={{
                                                        disabled: getDisable('coaNo', disabledFieldNames),
                                                        label: translate.get('LABEL.COA_NO'),
                                                        placeholder: translate.get('LABEL.COA_NO'),
                                                        size: 'small',
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <DatePicker
                                                name="dateReqCertificate"
                                                label={translate.get('LABEL.REQ_CERTIFICATE_DATE')}
                                                // minDate={new Date()}
                                                disabled={getDisable('dateReqCertificate', disabledFieldNames)}
                                                required
                                                onChangeValue={onDateReqCertificateChange}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <DatePicker
                                                name="dateCertificateExpire"
                                                label={translate.get('LABEL.CERTIFICATE_EXPIRE_DATE')}
                                                disabled={getDisable('dateCertificateExpire', disabledFieldNames)}
                                                required
                                            />
                                        </Grid>
                                    </Grid>
                                </MyAccordion>
                            </Grid>
                            {(projectData?.isLanguageTH || isAddOtherLanguage) && (
                                <Grid item xs={12} md={12} lg={12}>
                                    <ModeAccordion
                                        title={`${translate.get('LABEL.DATA_BEFORE_CERTIFICATE')}​ (${translate.get(
                                            'LABEL.THAI',
                                        )}​)`}
                                        renderViewComponent={() => renderViewComponent('TH')}
                                        renderEditComponent={() => renderEditComponent('TH')}
                                        fieldNames={certificateFieldNamesTH}
                                        isAddOtherLanguage={projectData?.isLanguageTH}
                                        onConfirm={
                                            currentSelectTab
                                                ? () => {}
                                                : () =>
                                                      handleSubmitUpdateData(
                                                          values,
                                                          props,
                                                          'TH',
                                                          certificateFieldNamesTH,
                                                      )
                                        }
                                        isViewMode={currentSelectFolder && !currentSelectTab}
                                        onClickEdit={() => {
                                            valueRef.current = props.form.getState().values
                                        }}
                                    />
                                </Grid>
                            )}

                            {(projectData?.isLanguageEN || isAddOtherLanguage) && (
                                <Grid item xs={12} md={12} lg={12}>
                                    <ModeAccordion
                                        title={`${translate.get('LABEL.DATA_BEFORE_CERTIFICATE')}​ (${translate.get(
                                            'LABEL.ENG',
                                        )}​)`}
                                        renderViewComponent={() => renderViewComponent('EN')}
                                        renderEditComponent={() => renderEditComponent('EN')}
                                        fieldNames={certificateFieldNamesEN}
                                        isAddOtherLanguage={projectData?.isLanguageEN}
                                        onConfirm={
                                            currentSelectTab
                                                ? () => {}
                                                : () =>
                                                      handleSubmitUpdateData(
                                                          values,
                                                          props,
                                                          'EN',
                                                          certificateFieldNamesEN,
                                                      )
                                        }
                                        isViewMode={currentSelectFolder && !currentSelectTab}
                                        onClickEdit={() => {
                                            valueRef.current = props.form.getState().values
                                        }}
                                    />
                                </Grid>
                            )}

                            {!(projectData?.isLanguageEN && projectData?.isLanguageTH) && !isUpdateSuccess && (
                                <Grid item xs={12} justify="flex-start">
                                    <AddBtn
                                        color="primary"
                                        onClick={
                                            isAddOtherLanguage ? handleCancelAddOtherLangauge : handleClickOtherLangauge
                                        }
                                    >
                                        {isAddOtherLanguage
                                            ? translate.get('BUTTON.CANCEL')
                                            : translate.get('BUTTON.ADD_BEFORE_CERTIFICATE_DATA') +
                                              `${
                                                  projectData?.isLanguageTH
                                                      ? translate.get('LABEL.ENG')
                                                      : translate.get('LABEL.THAI')
                                              }`}
                                    </AddBtn>
                                </Grid>
                            )}

                            <Grid item xs={12} md={12} lg={12}>
                                <UploadDoc
                                    name={'uploadFileCerDoc'}
                                    initialData={initialUploadCerDoc}
                                    documentTitleList={formatDocumentTopic}
                                    title={translate.get('LABEL.DOC_CERTIFIED')}
                                    isViewMode={true}
                                    disabledBtn={true}
                                    onClickOpenFile={onClickFileStamp}
                                />
                            </Grid>

                            <Grid item xs={12} md={12} lg={12}>
                                <UploadDoc
                                    initialData={initialUploadFileCer}
                                    documentTitleList={certificateTopicList}
                                    title={translate.get('LABEL.CERTIFICATE')}
                                    // isViewMode={isViewMode}
                                    isViewMode={true}
                                    disabledBtn={true}
                                    onClickOpenFile={onClickOpenFile}
                                />
                            </Grid>

                            {isShowUpdateDate && <DisplayUpdater />}

                            {!isViewMode && (
                                <Grid item xs={12}>
                                    <PageAction
                                        onClickSaveDraft={() => {
                                            props.form.change('saveType', 'DRAFT')
                                            props.handleSubmit()
                                        }}
                                        onClickSave={() => {
                                            props.form.change('saveType', 'SAVE')
                                            props.handleSubmit()
                                            invalid &&
                                                errors &&
                                                snackbarAction.openSnackbar({
                                                    message: translate.get('MESSAGE.M012'),
                                                    type: 'error',
                                                })
                                        }}
                                        onClickClose={handleBackToSearch}
                                    />
                                </Grid>
                            )}
                        </Grid>
                        <FormSpy subscription={{ dirty: true, values: true }} onChange={handleDirtyChange} />
                        <Dialog onRef={onRefDialog} {...configDialog} />
                    </>
                )
            }}
        </Form>
    )
}
export type GenerateCertificateREC2Type = { callbackSaveComplete?: (status: number, isDraft: boolean) => void }
const GenerateCertificateREC2: React.FC<GenerateCertificateREC2Type> = (props) => {
    const generateCertificate = useGenerateCertificate(props)
    return <GenerateCertificateREC2View {...generateCertificate} />
}

export default GenerateCertificateREC2
